import axios from "axios";

//'https://localhost:44304/api/';
//'https://portal.saiec.mx/api/'

const BASE_URL = '/api/';

export const ENDPIONTS = {
    CICLO_ESCOLAR: 'CicloEscolar',
    FOODITEM: 'FoodItem',
    ORDER: 'Alumno/Carrito',
    CATALOGOCOBRO: 'Alumno/ObtieneCobroAlumnoPorCicloEscolar',
    ORDERS: 'Alumno/ListarCobros',
    CICLO_ESCOLAR_SIGUIENTE: 'Alumno/CicloEscolarSiguiente',
    HISTORIAL_PAGOS: 'Alumno/HistorialPagos',
    ALUMNOS_SIGUIENTE_CICLO: 'Alumno/SiguienteCiclo',
    HISTORIAL_RECIBOS: 'Alumno/RecibosPorAlumno',
    ENVIAR_CODIGO_CANCELACION: 'Alumno/EnviarCodigoCancelacion',
    CANCELAR_RECIBO: 'Alumno/CancelarCodigo',
    REGLAS_COLEGIATURA_DETALLE: 'Alumno/ReglasColegiaturaDetalle',
    REGLA_COLEGIATURA_NO_USO_MES: 'Alumno/ReglaColegiaturaNoUsoMes',
    REGLA_COLEGIATURA_BAJA_SERVICIO: 'Alumno/ReglaColegiaturaBajaServicio',
    REGLA_COLEGIATURA_REVERTIR_EVIDENCIA: 'Alumno/ReglaColegiaturaRevertirEvidencia'
}

export const createAPIEndpoint = endpoint => {

    let url = BASE_URL + endpoint + '/';
    return {
        fetchAll: () => axios.get(url),
        fetchById: id => axios.get(url + id),
        create: newRecord => axios.post(url, newRecord),
        update: (id, updatedRecord) => axios.put(url + id, updatedRecord),
        delete: id => axios.delete(url + id),
        fetchCicloEscolarSiguiente: () => axios.get(url),
        fetchHistory: parametro => axios.get(url + parametro),
        fetchAlumnosSiguienteCiclo: () => axios.get(url),
        fetchVoucher: parametro => axios.get(url + parametro),
        enviaCodigoCancelacion: parametro => axios.get(url + parametro)
    }
}

export const createAPIEndpoint2 = endpoint => {

    let url = BASE_URL + endpoint;
    return {
        fetchById: id => axios.get(url +"?idusuario=" + id),
    }
}

export const createAPIEndpoint3 = endpoint => {

    let url = BASE_URL + endpoint;
    return {
        fetchAllPriceByStudent: (id, ciclo) => axios.get(url + "?id=" + id +"&ciclo="+ciclo),
    }
}